import { ITrackingSettingsData } from 'types';
import { getStorageKeysForNetwork } from 'utils/LocalstorageUtils';

export const useSafeSettingsStorage = () => {
  const storageKeys = getStorageKeysForNetwork();

  const saveToLocalStorage = (data: ITrackingSettingsData): void => {
    const storageData = loadStorageData();
    const updatedData = [data, ...storageData.filter((x) => x.safeId !== data.safeId)];
    localStorage.setItem(storageKeys.safeSettings, JSON.stringify(updatedData));
  };

  const loadStorageData = (): ITrackingSettingsData[] => {
    const data = localStorage.getItem(storageKeys.safeSettings);

    return data ? JSON.parse(data) : [];
  };

  const getSafeTrackingData = (safeId: string): ITrackingSettingsData => {
    const data = loadStorageData();

    return (
      data.find((obj) => obj.safeId === safeId) || {
        safeId,
        isPrivacyMode: true,
      }
    );
  };

  return {
    getSafeTrackingData,
    saveToLocalStorage,
  };
};
